export const validateCardInfo = infoCard => {
  if (
    !infoCard.cardInfo.number ||
    !infoCard.cardInfo.name ||
    !infoCard.cardInfo.card_exp_month ||
    !infoCard.cardInfo.card_exp_year ||
    !infoCard.cardInfo.cvc ||
    !infoCard.cardInfo.dni
  ) {
    return true;
  } else {
    return false;
  }
};
